import * as selectize from "selectize";

$(".mail-merge-button").on("click", function(evt) {
  $(".mail-merge-csv-field").toggle("display");
  console.log("clicked!");
});

let selectMe = $(".email-select-2").selectize({
  plugins: ["remove_button"],
  valueField: "id",
  searchField: ["title", "first_name", "last_name", "email"],
  options: [],
  multiple:"multiple",
  tags: true,
  create: false,
  render: {
    item: function(item, escape) {
      if (item.title != null) {
        return (
          '<div class="item" series="camp" data-item-type="camp">' +
          escape(item.title) +
          "</div>"
        );
      }
      if (item.first_name != null) {
        return (
          '<div class="item" series="user" data-item-type="user">' +
          escape(item.first_name) +
          " " +
          escape(item.last_name) +
          " - " +
          escape(item.email) +
          "</div>"
        );
      }
    },
    option: function(item, escape) {
      if (item.title != null) {
        return (
          '<div class="option" series="camp" data-item-type="camp">' +
          '<span class="title">' +
          escape(item.title) +
          " </span>" +
          "</div>"
        );
      }
      if (item.first_name != null) {
        return (
          '<div class="option" series="user" data-item-type="user">' +
          '<span class="name">' +
          escape(item.first_name) +
          " " +
          escape(item.last_name) +
          " </span>" +
          " - " +
          escape(item.email) +
          "</div>"
        );
      }
    }
  },
  load: function(query, callback) {
    if (!query.length) return callback();
    $.ajax({
      url: "/admin/mail_merge_endpoint.json",
      type: "GET",
      dataType: "json",
      data: {
        q: query,
        page_limit: 10
      },
      error: function() {
        callback();
      },
      success: function(res) {
        callback(res);
      }
    });
  }
});
